import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfOurGuests() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const testimonials = [{
    author: "Marcus Vane",
    quote: "The 2018 Reserve Cabernet is a masterclass in balance—the terroir of VineEssence speaks through every velvety note.",
    position: "Master Sommelier",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/sommelier_marcus.png"
  }, {
    author: "Elena Rossi",
    quote: "Rarely do I find a vineyard that captures the soul of the valley so purely. Their Cellar Club is essential for any collector.",
    position: "Wine Critic",
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/critic_elena.png"
  }];
  return <section data-section-id="37607" id="from-our-connoisseurs" ref={ref} className={`bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none z-0 flex justify-center items-center">
        <span className="font-serif text-[200px] md:text-[300px] leading-none opacity-5 text-primary">
          &rdquo;
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-3xl mx-auto">
          <CarouselContent>
            {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 py-8">
                  {}
                  <p className="font-serif italic text-2xl md:text-4xl leading-relaxed text-foreground mb-10 max-w-2xl mx-auto">
                    {item.quote}
                  </p>

                  {}
                  <div className="flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-12 border border-secondary/30">
                      <AvatarImage src={item.img} alt={item.author} />
                      <AvatarFallback className="bg-muted text-muted-foreground text-xs font-mono">
                        {item.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>

                    <div className="space-y-1">
                      <div className="font-sans font-medium text-base tracking-wide text-primary">
                        {item.author}
                      </div>
                      <div className="font-mono text-[10px] text-muted-foreground uppercase tracking-widest">
                        {item.position}
                      </div>
                    </div>

                    {}
                    <div className="flex gap-2 mt-1">
                      {[...Array(5)].map((_, dotIndex) => <div key={dotIndex} className="size-1.5 rounded-full bg-secondary" />)}
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <CarouselPrevious className="hidden md:flex -left-16 bg-transparent border-primary/10 text-primary/60 hover:bg-primary/5 hover:text-primary hover:border-primary/20 transition-colors" />
          <CarouselNext className="hidden md:flex -right-16 bg-transparent border-primary/10 text-primary/60 hover:bg-primary/5 hover:text-primary hover:border-primary/20 transition-colors" />
        </Carousel>
      </div>
    </section>;
}